// The tempurpedic account-page shell shared by the profile-edit /
// change-password / address-book / address-delete documents: the capped-width
// wrapper, the "Your Account / ..." breadcrumbs-block, and the page heading.
// Crumbs render as links when they carry an href, plain text otherwise, joined
// by " / " like the legacy breadcrumbs-block markup.
import { Immutable } from "immer";
import React from "react";

type ICrumb = {
    label: string;
    href?: string;
};

type IProps = Immutable<{
    crumbs: ICrumb[];
    heading: string;
}> & {
    children?: React.ReactNode;
};

export const AccountBreadcrumbShell = (props: IProps): React.JSX.Element => (
    <div className="l-capped-width">
        <section className="breadcrumbs-block">
            {props.crumbs.map((crumb, i) => (
                <React.Fragment key={i}>
                    {i > 0 && " / "}
                    {crumb.href ? (
                        <a href={crumb.href}>{crumb.label}</a>
                    ) : (
                        crumb.label
                    )}
                </React.Fragment>
            ))}
        </section>

        <div className="account-page-title">
            <h2>{props.heading}</h2>
        </div>

        {props.children}
    </div>
);
